import {Module, MutationTree} from "vuex";
import {NamedRouting} from "@/domain/utils/NamedRouting";

export class NextViewState {
  constructor(nextView: string | null) {
    if (nextView) {
      this.nextView = JSON.parse(nextView);
    }
  }

  public nextView?: NamedRouting;
}

const mutations: MutationTree<NextViewState> = {
  setNextView(state: NextViewState, nextView: NamedRouting): void {
    sessionStorage.setItem('nextView', JSON.stringify(nextView));
    state.nextView = nextView;
  },
};

export const NextViewStore: Module<NextViewState, any> = {
  namespaced: true,
  state: new NextViewState(sessionStorage.getItem('nextView')),
  mutations,
};